module.exports = __webpack_public_path__ + "static/media/jeep.f08a24e2.png";